module.exports = __webpack_public_path__ + "img/51.6.CODm.01fbdf8b.png";